/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentStates } from './equipment-states';
import { SortExpression } from './sort-expression';


export interface SearchContainersRequest { 
    skip?: number;
    take?: number;
    includeTotalCount?: boolean | null;
    sortExpressions?: Array<SortExpression> | null;
    keyword?: string | null;
    facilityIds?: Array<string> | null;
    equipmentStates?: Array<EquipmentStates> | null;
}

